import { POST_INFO_CARDS_START } from '../../types';

export const post_info_cards = (payload) => ({
  type: POST_INFO_CARDS_START,
  payload,
});
